import Vue from 'vue'

export default Vue.extend({
  name: 'lx-form-field-label',
  props: {
    required: Boolean,
  },
})
